import { createContext, ReactElement, useContext, useMemo } from "react"

import { IDeviceFormContextValue } from "../../../types/providerTypes"
import CoreEVACDeviceDetails from "../../evac/formPages/coreEVACDeviceDetails"
import { EVACDeviceFormData } from "../../types/providerTypes"
import { CreateV2GBundleContext } from "../providers/baseProviders/createV2GBundleProvider"

const BundleEVACContext = createContext(
    {} as IDeviceFormContextValue<EVACDeviceFormData>
)

const CoreV2GEVACDetails = (): ReactElement => {
    const {
        currentIndex,
        setCurrentIndex,
        canEditManufacturer,
        evacFormData,
        setEvacFormData,
        errors,
    } = useContext(CreateV2GBundleContext)

    const contextValue = useMemo(
        () => ({
            currentIndex,
            setCurrentIndex,
            canEditManufacturer,
            formData: evacFormData,
            setFormData: setEvacFormData,
            onSubmit: async () => undefined,
            submitLoading: false,
            submitSuccessful: false,
            saveDraft: async () => undefined,
            saveDraftLoading: false,
            saveDraftSuccessful: false,
            formIsLoading: false,
            errors,
        }),
        [
            currentIndex,
            setCurrentIndex,
            canEditManufacturer,
            evacFormData,
            setEvacFormData,
            errors,
        ]
    )

    return (
        <BundleEVACContext.Provider value={contextValue}>
            <CoreEVACDeviceDetails
                context={BundleEVACContext}
                bundleMode
                hideDraftAction
            />
        </BundleEVACContext.Provider>
    )
}

export default CoreV2GEVACDetails
